import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Companies from "../views/Companies.vue";
import Companies_1 from "../views/Companies_1.vue";
import CompaniesList from "../views/CompaniesList.vue";
import Entities from "../views/Entities.vue";
import EntitiesList from "../views/EntitiesList.vue";
import EntitiesView from "../views/EntitiesView.vue";
import Adresses from "../views/Adresses.vue";
import AdressList from "../views/AdressList.vue";
import Tags from "../views/Tags.vue";
import Tagcategories from "../views/Tagcategories.vue";
import Specifications from "../views/Specifications.vue";
import Treatments from "../views/Treatments.vue";
import Preparations from "../views/Preparations.vue";
import Units from "../views/Units.vue";
import Projects from "../views/Projects.vue";
import ProjectsList from "../views/ProjectsList.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Error404 from "../views/error/404.vue";
import Error500 from "../views/error/500.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {needsAuth:true}
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {needsAuth:false}
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {needsAuth:false}
    },
    {
      path: "/about",
      name: "about",
      component: About,
      meta: {needsAuth:true}
    },
    {
      path: "/projects",
      name: "projects",
      component: ProjectsList,
      meta: {needsAuth:true}
    },
    {
      path: "/projects/create",
      name: "projects_create",
      component: Projects,
      meta: {needsAuth:true}
    },
    {
      path: "/projects/:id",
      name: "projects_update",
      component: Projects,
      meta: {needsAuth:true}
    },
    {
      path: "/projects/:id",
      name: "projects_delete",
      component: Projects,
      meta: {needsAuth:true}
    },
    
    {
      path: "/companies",
      name: "companies",
      component: CompaniesList,
      meta: {needsAuth:true}
    },
    {
      path: "/recipesteps/create",
      name: "recipesteps_create",
      component: Companies_1,
      meta: {needsAuth:true}
    },
    {
      path: "/companies/create",
      name: "companies_create",
      component: Companies,
      meta: {needsAuth:true}
      
    },
    {
      path: "/companies/:id",
      name: "companies_update",
      component: Companies,
      meta: {needsAuth:true}
    },
    {
      path: "/companies/:id",
      name: "companies_delete",
      component: Companies,
      meta: {needsAuth:true}
    },
    {
      path: "/adresses",
      name: "adresses",
      component: AdressList,
      meta: {needsAuth:true}
    },
    {
      path: "/adresses/create",
      name: "adresses_create",
      component: Adresses,
      meta: {needsAuth:true}
    },
    {
      path: "/adresses/:id",
      name: "adresses_update",
      component: Adresses,
      meta: {needsAuth:true}
    },
    {
      path: "/adresses/:id",
      name: "adresses_delete",
      component: Adresses,
      meta: {needsAuth:true}
    },
    {
      path: "/entities",
      name: "entities",
      component: EntitiesList,
      meta: {needsAuth:true}
    },
    {
      path: "/entities/create",
      name: "entities_create",
      component: Entities,
      meta: {needsAuth:true}
    },
    {
      path: "/entities/:id",
      name: "entities_update",
      component: Entities,
      meta: {needsAuth:true}
    },
    {
      path: "/entities/:id/show",
      name: "entities_show",
      component: EntitiesView,
      meta: {needsAuth:true}
    },
    {
      path: "/entities/:id",
      name: "entities_delete",
      component: Entities,
      meta: {needsAuth:true}
    },
    {
      path: "/tags/create",
      name: "tags_create",
      component: Tags,
      meta: {needsAuth:true}
    },
    {
      path: "/tags/:id",
      name: "tags_update",
      component: Tags,
      meta: {needsAuth:true}
    },
    {
      path: "/tags/:id",
      name: "tags_delete",
      component: Tags,
      meta: {needsAuth:true}
    },
    {
      path: "/tagcategories/create",
      name: "tagcategories_create",
      component: Tagcategories,
      meta: {needsAuth:true}
    },
    {
      path: "/tagcategories/:id",
      name: "tagcategories_update",
      component: Tagcategories,
      meta: {needsAuth:true}
    },
    {
      path: "/tagcategories/:id",
      name: "tagcategories_delete",
      component: Tagcategories,
      meta: {needsAuth:true}
    },
    {
      path: "/specifications/create",
      name: "specifications_create",
      component: Specifications,
      meta: {needsAuth:true}
    },
    {
      path: "/specifications/:id",
      name: "specifications_update",
      component: Specifications,
      meta: {needsAuth:true}
    },
    {
      path: "/specifications/:id",
      name: "specifications_delete",
      component: Specifications,
      meta: {needsAuth:true}
    },
    {
      path: "/treatments/create",
      name: "treatments_create",
      component: Treatments,
      meta: {needsAuth:true}
    },
    {
      path: "/treatments/:id",
      name: "treatments_update",
      component: Treatments,
      meta: {needsAuth:true}
    },
    {
      path: "/treatments/:id",
      name: "treatments_delete",
      component: Treatments,
      meta: {needsAuth:true}
    },
    {
      path: "/preparations/create",
      name: "preparations_create",
      component: Preparations,
      meta: {needsAuth:true}
    },
    {
      path: "/preparations/:id",
      name: "preparations_update",
      component: Preparations,
      meta: {needsAuth:true}
    },
    {
      path: "/preparations/:id",
      name: "preparations_delete",
      component: Preparations,
      meta: {needsAuth:true}
    },
    {
      path: "/units/create",
      name: "units_create",
      component: Units,
      meta: {needsAuth:true}
    },
    {
      path: "/units/:id",
      name: "units_update",
      component: Units,
      meta: {needsAuth:true}
    },
    {
      path: "/units/:id",
      name: "units_delete",
      component: Units,
      meta: {needsAuth:true}
    },
    {
      path: "/404",
      name: "Error404",
      component: Error404,
      meta: {needsAuth:true}
    },
    {
      path: "/500",
      name: "Error500",
      component: Error500,
      meta: {needsAuth:true}
    },
  ]
});
